module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "custom-classes-transition",
      "enter-active-class": ("animated " + (_vm.settingsObj.animation))
    }
  }, [_c('div', {
    staticClass: "container"
  }, _vm._l((this[_vm.endpoint]), function(item, i) {
    return _c('section', {
      key: i,
      ref: ("bkg-" + i),
      refInFor: true,
      class: ['background', ("" + (_vm.settingsObj.themeColor)), 'lighten-1', "white--text", 'mb-1'],
      attrs: {
        "data-key": ("" + i)
      }
    }, [_c('v-container', {
      attrs: {
        "grid-list-md": ""
      }
    }, [_c('v-layout', {
      staticClass: "content-wrapper",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "content-box",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg6": "",
        "mt-5": ""
      }
    }, [_c('v-flex', {
      staticClass: "content-inner",
      attrs: {
        "grid-list-md": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md2": "",
        "mt-2": "",
        "pl-2": ""
      }
    }, [_c('v-avatar', {
      staticClass: "elevation-15",
      attrs: {
        "tile": false,
        "size": "100px"
      },
      on: {
        "click": function (e) {
          _vm.nextImg(i)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": "avatar"
      }
    })])], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "content-title",
      attrs: {
        "md10": ""
      }
    }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-list', {
      staticClass: "content-inner__list"
    }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "white--text"
    }, [_vm._v(_vm._s(item.date) + "\n                                        ")])], 1)], 1), _vm._v(" "), _vm._l((item.descArr), function(activity, j) {
      return _c('v-list-tile', {
        key: j
      }, [_c('v-icon', {
        staticClass: "white--text icon"
      }, [_vm._v("check_box")]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(activity))])], 1)], 1)
    })], 2)], 1)], 1)], 1)], 1)], 1)], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-334da022","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ParallaxCardList.vue
// module id = 461
// module chunks = 0